import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import { FiMenu, FiX } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', to: '/#about' },
    { name: 'Expertise', to: '/#expertise' },
    { name: 'Projects', to: '/#projects' },
    { name: 'Philosophy', to: '/#philosophy' },
    { name: 'Contact', to: '/#contact' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <HashLink smooth to="/#top" className="text-2xl font-bold tracking-tight text-slate-900 hover:text-teal-700 transition-colors">
          Marjo Villarosa<span className="text-teal-600">.</span>
        </HashLink>

        {/* Desktop Nav */}
        <div className="hidden md:flex space-x-8 items-center">
          {navLinks.map((link) => (
            <HashLink 
              key={link.name} 
              smooth 
              to={link.to}
              className="text-sm font-medium text-slate-600 hover:text-teal-600 transition-colors"
            >
              {link.name}
            </HashLink>
          ))}
          <HashLink
            smooth 
            to="/#contact" 
            className="px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors"
          >
            Get in Touch
          </HashLink>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-slate-800" onClick={() => setIsOpen(!isOpen)}>
          <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-lg border-t border-slate-100 py-6 px-6 md:hidden flex flex-col space-y-4">
          {navLinks.map((link) => (
            <HashLink 
              key={link.name} 
              smooth 
              to={link.to}
              onClick={() => setIsOpen(false)}
              className="text-lg font-medium text-slate-800 hover:text-teal-600"
            >
              {link.name}
            </HashLink>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;